if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.form.addEventListener("change", this.onVariantChange.bind(this));
        this.backInStock = this.querySelector('.js-back-in-stock');
        this.footer = document.querySelector('.js-site-footer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.productPage = this.getAttribute("data-product-page");
        this.variantDataObject = this.querySelector('[type="application/json"]');
        this.mq = window.matchMedia('(max-width: 749px)');

        if (this.productPage) {

          if (this.variantDataObject) {
            this.onVariantChange(event, true);
          }

          const productPageSlider = document.querySelector('.js-product-media-slider');
          
          if (productPageSlider) {
            productPageSlider.classList.remove('product__media-slider--hidden');
          }
        }

        const resizeObserver = new ResizeObserver(() => { this.updateFooterPadding() });
        resizeObserver.observe(this);

        this.updateFooterPadding();
      }

      updateFooterPadding() {
        if (!this.footer) return;

        if (this.productPage && this.classList.contains('sold-out') && this.backInStock && this.mq.matches) {
          this.footer.style.paddingBottom = `calc(4rem + ${this.backInStock.offsetHeight}px)`;
        } else {
          this.footer.style.paddingBottom = '';
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        document.dispatchEvent(
          new CustomEvent('alert:clear')
        );

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartAdd);
          this.error = false;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");

          const addButtons = document.querySelectorAll(".js-add-button");
          
          if (addButtons.length) {
            addButtons.forEach((button) => {
              button.classList.remove("loading");
            });
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (!errorMessage) return;

        document.dispatchEvent(
          new CustomEvent('alert:show', { 
            detail: {
              data: {
                message: errorMessage,
                status: 'Error'
              }
            }
          })
        );
      }

      onVariantChange(event, sliderOnly) {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.setUnavailable();

          if (this.productPage) {
            this.classList.remove('sold-out');
            this.updateFooterPadding();
          }
        } else {
          this.updateSlider();

          if (sliderOnly) return;

          this.updateURL();
          this.renderProductInfo();
        }
      }
      
      updateSlider() {
        const id = this.currentVariant?.featured_image?.id;

        if (id) {
          const slider = document.querySelector(this.getAttribute('data-linked-slider'));
          
          if (!slider) return;

          const slide = slider.querySelector(`.js-carousel-slide[data-media-id="${id}"]`);

          if (!slide) return;

          const index = slide.getAttribute('data-slider-index');

          slider.dispatchEvent(
            new CustomEvent('slider:go', {
              detail: {
                index
              }
            })
          )
        }
      }

      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll('.js-product-form-input:checked'),
          (input) => input.value
        );
      }
    
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }
    
      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }
    
      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(":checked").value === variant.option1
        );

        const inputWrappers = [...this.querySelectorAll(".js-product-options")];

        inputWrappers.forEach((option, index) => {
          if (index === 0) return;

          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
                    
          const previousOptionSelected =
            inputWrappers[index - 1].querySelector(":checked").value;

          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);

          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove('disabled');
          } else {
            input.classList.add('disabled');
          }
        });
      }

      updatePrice() {
        const prices = this.querySelectorAll('.js-product-price');

        if (!prices.length) return;

        let content;

        if (this.currentVariant.compare_at_price_unformatted > this.currentVariant.price_unformatted) {
          content = `
            <span class="visually-hidden visually-hidden--inline">${window.productStrings.salePrice}</span>
            <span class="price-item price-item--sale">
              ${this.currentVariant.price}
            </span>
            <span class="visually-hidden visually-hidden--inline">${window.productStrings.regularPrice}</span>
            <span>
              <s class="price-item price-item--compare">
                ${this.currentVariant.compare_at_price}
              </s>
            </span>
          `;
        } else {
          content = `
            <span class="visually-hidden visually-hidden--inline">${window.productStrings.regularPrice}</span>
            <span class="price-item">
              ${this.currentVariant.price}
            </span>
          `;
        }

        prices.forEach((price) => { price.innerHTML = content; });
      }

      updateId() {
        const id = this.querySelector('.js-variant-id');

        if (!id) return;

        id.value = this.currentVariant.id;
      }

      updateBackInStockId() {
        if (!this.backInStock) return;
        
        this.backInStock.setAttribute('data-variant-id', this.currentVariant.id);
      }

      updateAvailability() {
        const addButton = this.querySelector('.js-add-button');

        if (!addButton) return;

        if (this.currentVariant.available) {
          addButton.removeAttribute('disabled');
          addButton.innerText = window.variantStrings.addToBag;

          if (this.productPage) {
            this.classList.remove('sold-out');
            this.updateFooterPadding();
          }
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButton.innerText = window.variantStrings.soldOut;

          if (this.productPage) {
            this.classList.add('sold-out');
            this.updateFooterPadding();
          }
        }
      }

      setUnavailable() {
        const addButton = this.querySelector('.js-add-button');

        if (!addButton) return;

        addButton.setAttribute('disabled', 'disabled');
        addButton.innerText = window.variantStrings.unavailable;
      }

      updateCardURL() {
        const url = this.querySelector('.js-product-link');

        if (!url) return;
        
        url.href = this.currentVariant.url;
      }

      renderProductInfo() {
        this.updateId();
        this.updateBackInStockId();
        this.updatePrice();
        this.updateAvailability();
        this.updateCardURL();
      }
    
      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(this.variantDataObject.textContent);
        return this.variantData;
      }
    }
  );
}
